import React from 'react'

export default function PackingListDetails() {
  return (
    <div>PackingListDetails</div>
  )
}
